/* jshint esversion: 6 */

export default (function(seconds){

    let player;

    let iframe = document.querySelector('iframe');
    if (typeof Vimeo == "undefined") {
        console.log("Warning: the Vimeo object is not available");
        return;
    } else {
        player = new Vimeo.Player(iframe);
        if (typeof player == "undefined") {
            console.log("Warning: the video player object is undefined");
            return;
        }
    }

    if (seconds < 1) {
        return;
    }

    console.log(`Advance video by ${seconds} seconds`);

    player.setCurrentTime(seconds);

});


